const today = [
  {
    date: '2025-01-09T00:00:00Z',
    price: 10.144
  },
  {
    date: '2025-01-09T01:00:00Z',
    price: 10
  },
  {
    date: '2025-01-09T02:00:00Z',
    price: 9.877
  },
  {
    date: '2025-01-09T03:00:00Z',
    price: 9.522
  },
  {
    date: '2025-01-09T04:00:00Z',
    price: 9.828
  },
  {
    date: '2025-01-09T05:00:00Z',
    price: 10.265
  },
  {
    date: '2025-01-09T06:00:00Z',
    price: 13.354
  },
  {
    date: '2025-01-09T07:00:00Z',
    price: 14.88
  },
  {
    date: '2025-01-09T08:00:00Z',
    price: 16.488
  },
  {
    date: '2025-01-09T09:00:00Z',
    price: 15.615
  },
  {
    date: '2025-01-09T10:00:00Z',
    price: 14.764
  },
  {
    date: '2025-01-09T11:00:00Z',
    price: 14.021
  },
  {
    date: '2025-01-09T12:00:00Z',
    price: 12.818
  },
  {
    date: '2025-01-09T13:00:00Z',
    price: 12.115
  },
  {
    date: '2025-01-09T14:00:00Z',
    price: 12.395
  },
  {
    date: '2025-01-09T15:00:00Z',
    price: 12.753
  },
  {
    date: '2025-01-09T16:00:00Z',
    price: 12.375
  },
  {
    date: '2025-01-09T17:00:00Z',
    price: 13.091
  },
  {
    date: '2025-01-09T18:00:00Z',
    price: 13.475
  },
  {
    date: '2025-01-09T19:00:00Z',
    price: 12.544
  },
  {
    date: '2025-01-09T20:00:00Z',
    price: 11.923
  },
  {
    date: '2025-01-09T21:00:00Z',
    price: 10.499
  },
  {
    date: '2025-01-09T22:00:00Z',
    price: 10.11
  },
  {
    date: '2025-01-09T23:00:00Z',
    price: 8.819
  }
]

const yesterday = [
  {
    date: '2025-01-08T00:00:00Z',
    price: 7.105
  },
  {
    date: '2025-01-08T01:00:00Z',
    price: 6.801
  },
  {
    date: '2025-01-08T02:00:00Z',
    price: 6.334
  },
  {
    date: '2025-01-08T03:00:00Z',
    price: 5.701
  },
  {
    date: '2025-01-08T04:00:00Z',
    price: 6.629
  },
  {
    date: '2025-01-08T05:00:00Z',
    price: 7.207
  },
  {
    date: '2025-01-08T06:00:00Z',
    price: 8.27
  },
  {
    date: '2025-01-08T07:00:00Z',
    price: 10.073
  },
  {
    date: '2025-01-08T08:00:00Z',
    price: 12.822
  },
  {
    date: '2025-01-08T09:00:00Z',
    price: 10.818
  },
  {
    date: '2025-01-08T10:00:00Z',
    price: 9.465
  },
  {
    date: '2025-01-08T11:00:00Z',
    price: 10.001
  },
  {
    date: '2025-01-08T12:00:00Z',
    price: 8.999
  },
  {
    date: '2025-01-08T13:00:00Z',
    price: 9.72
  },
  {
    date: '2025-01-08T14:00:00Z',
    price: 11.019
  },
  {
    date: '2025-01-08T15:00:00Z',
    price: 12.78
  },
  {
    date: '2025-01-08T16:00:00Z',
    price: 13.582
  },
  {
    date: '2025-01-08T17:00:00Z',
    price: 15.546
  },
  {
    date: '2025-01-08T18:00:00Z',
    price: 14.923
  },
  {
    date: '2025-01-08T19:00:00Z',
    price: 14.648
  },
  {
    date: '2025-01-08T20:00:00Z',
    price: 13.686
  },
  {
    date: '2025-01-08T21:00:00Z',
    price: 12.786
  },
  {
    date: '2025-01-08T22:00:00Z',
    price: 11.592
  },
  {
    date: '2025-01-08T23:00:00Z',
    price: 10.359
  }
]

const lastMonth = [
  {
    date: '2024-12-01T00:00:00Z',
    price: 9.459
  },
  {
    date: '2024-12-02T00:00:00Z',
    price: 10.915
  },
  {
    date: '2024-12-03T00:00:00Z',
    price: 14.407
  },
  {
    date: '2024-12-04T00:00:00Z',
    price: 18.247
  },
  {
    date: '2024-12-05T00:00:00Z',
    price: 10.62
  },
  {
    date: '2024-12-06T00:00:00Z',
    price: 8.637
  },
  {
    date: '2024-12-07T00:00:00Z',
    price: 7.151
  },
  {
    date: '2024-12-08T00:00:00Z',
    price: 9.907
  },
  {
    date: '2024-12-09T00:00:00Z',
    price: 9.959
  },
  {
    date: '2024-12-10T00:00:00Z',
    price: 14.993
  },
  {
    date: '2024-12-11T00:00:00Z',
    price: 26.654
  },
  {
    date: '2024-12-12T00:00:00Z',
    price: 39.534
  },
  {
    date: '2024-12-13T00:00:00Z',
    price: 17.847
  },
  {
    date: '2024-12-14T00:00:00Z',
    price: 10.123
  },
  {
    date: '2024-12-15T00:00:00Z',
    price: 4.685
  },
  {
    date: '2024-12-16T00:00:00Z',
    price: 4.867
  },
  {
    date: '2024-12-17T00:00:00Z',
    price: 8.63
  },
  {
    date: '2024-12-18T00:00:00Z',
    price: 5.497
  },
  {
    date: '2024-12-19T00:00:00Z',
    price: 5.203
  },
  {
    date: '2024-12-20T00:00:00Z',
    price: 7.637
  },
  {
    date: '2024-12-21T00:00:00Z',
    price: 2.214
  },
  {
    date: '2024-12-22T00:00:00Z',
    price: 2.293
  },
  {
    date: '2024-12-23T00:00:00Z',
    price: 5.91
  },
  {
    date: '2024-12-24T00:00:00Z',
    price: 10.249
  },
  {
    date: '2024-12-25T00:00:00Z',
    price: 9.863
  },
  {
    date: '2024-12-26T00:00:00Z',
    price: 11.289
  },
  {
    date: '2024-12-27T00:00:00Z',
    price: 12.171
  },
  {
    date: '2024-12-28T00:00:00Z',
    price: 12.264
  },
  {
    date: '2024-12-29T00:00:00Z',
    price: 10.528
  },
  {
    date: '2024-12-30T00:00:00Z',
    price: 7.816
  },
  {
    date: '2024-12-31T00:00:00Z',
    price: 6.21
  }
]

const lastYear = [
  {
    date: '2024-01-01T00:00:00Z',
    price: 7.657
  },
  {
    date: '2024-02-01T00:00:00Z',
    price: 6.134
  },
  {
    date: '2024-03-01T00:00:00Z',
    price: 6.47
  },
  {
    date: '2024-04-01T00:00:00Z',
    price: 6.236
  },
  {
    date: '2024-05-01T00:00:00Z',
    price: 6.721
  },
  {
    date: '2024-06-01T00:00:00Z',
    price: 7.289
  },
  {
    date: '2024-07-01T00:00:00Z',
    price: 6.77
  },
  {
    date: '2024-08-01T00:00:00Z',
    price: 8.205
  },
  {
    date: '2024-09-01T00:00:00Z',
    price: 7.831
  },
  {
    date: '2024-10-01T00:00:00Z',
    price: 8.61
  },
  {
    date: '2024-11-01T00:00:00Z',
    price: 11.391
  },
  {
    date: '2024-12-01T00:00:00Z',
    price: 10.832
  }
]

export const SampleData = {
  today: today.map((entry) => ({
    date: Date.parse(entry.date),
    price: entry.price
  })),
  yesterday: yesterday.map((entry) => ({
    date: Date.parse(entry.date),
    price: entry.price
  })),
  last_30_days: lastMonth.map((entry) => ({
    date: Date.parse(entry.date),
    price: entry.price
  })),
  previous_month: lastMonth.map((entry) => ({
    date: Date.parse(entry.date),
    price: entry.price
  })),
  last_12_months: lastYear.map((entry) => ({
    date: Date.parse(entry.date),
    price: entry.price
  })),
  previous_year: lastYear.map((entry) => ({
    date: Date.parse(entry.date),
    price: entry.price
  }))
}
